var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import BS_Modal from 'bootstrap/js/dist/Modal';
export class List extends Component {
    constructor() {
        super('List', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if ($('body').hasClass('single-product')) {
                this.modal = new BS_Modal($('#modal-add-to-list').get(0), { keyboard: false });
                $('.btn-add-product').on('click', (event, button) => {
                    event.preventDefault();
                    const isLoggedIn = button.data('loggedIn') === '1' ? true : false;
                    if (!isLoggedIn) {
                        this.addProductToList(button);
                    }
                    else {
                        this.productID = parseInt(button.data('id'));
                        this.modal.show();
                    }
                });
                $('#btn-add-to-list').on('click', (event, button) => __awaiter(this, void 0, void 0, function* () {
                    const listID = parseInt($('#select-existing-lists').val());
                    console.log(listID, $('#select-existing-lists').val());
                    if (listID === 0) {
                        $('#input-new-list-name').get(0).focus();
                    }
                    else {
                        this.addProductToList(button, this.productID, listID);
                    }
                }));
                $('#btn-create-list').on('click', (event, button) => __awaiter(this, void 0, void 0, function* () {
                    const listName = $('#input-new-list-name').val();
                    if (listName.length === 0) {
                        $('#input-new-list-name').get(0).focus();
                    }
                    else {
                        this.addProductToList(button, this.productID, listName);
                    }
                }));
            }
            $('.btn-remove-product').on('click', (event, button) => __awaiter(this, void 0, void 0, function* () {
                const message = $('html').attr('lang') == 'fr_FR' ? 'Êtes-vous sûr de vouloir supprimer «product_name» de votre liste?' : 'Are you sure you want to removes "product_name" from your list?';
                if (!confirm(message.replace('product_name', button.parent().find('h2').text())))
                    event.preventDefault();
            }));
            let titleSaveTimeout;
            $('#list-title').on('keyup', (event, input) => __awaiter(this, void 0, void 0, function* () {
                clearTimeout(titleSaveTimeout);
                titleSaveTimeout = window.setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                    input.attr('disabled', 'disabled');
                    input.parent().append(this.create_spinner());
                    const response = yield $.httpRequest({
                        url: '/wp-admin/admin-ajax.php',
                        type: 'POST',
                        body: {
                            action: 'update_list_title',
                            title: input.val(),
                        },
                        dataType: 'json'
                    });
                    input.parent().find('.spinner').remove();
                    input.removeAttr('disabled');
                }), 1500);
            }));
            // List counter
            const listCounter = parseInt(localStorage.getItem('list-product-count'));
            this.updateCounter(listCounter);
            this.loadProducCount();
            // Component initialization done
            this.success();
        });
    }
    create_spinner() {
        return $.parseHTML('<div class="spinner"><div class="spinner-border spinner-border-sm"></div></div>');
    }
    loadProducCount() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield $.httpRequest({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                body: {
                    action: 'get_list_product_count',
                },
                dataType: 'json'
            });
            this.updateCounter(response.count);
            localStorage.setItem('list-product-count', response.count);
        });
    }
    updateCounter(value) {
        $('#list-product-count').text(value > 0 ? value : '');
    }
    addProductToList(button, productId = null, list = null) {
        return __awaiter(this, void 0, void 0, function* () {
            button.append(this.create_spinner()).addClass('is-loading');
            const response = yield $.httpRequest({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                body: {
                    action: 'add_product_to_list',
                    product_id: productId,
                    list: list
                },
                dataType: 'json'
            });
            this.modal.hide();
            const $toast = $('.toast').addClass('show').find('.toast-message');
            $toast.text(response.message);
            if (!response.success) {
                $toast.addClass('error');
            }
            else {
                $toast.removeClass('error');
                this.loadProducCount();
            }
            setTimeout(() => {
                $('.toast').removeClass('show');
            }, 6000);
            $('#input-new-list-name').val('');
            button.removeClass('is-loading').find('.spinner').remove();
        });
    }
}
